import { Minus, Plus } from 'lucide-react'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'
import { Button } from '@/ui/shadcn/button'

interface StepperProps extends Omit<ComponentProps<'div'>, 'onChange'> {
  label: string
  value: number
  min: number
  max: number
  onChange: (value: number) => void
}

export function Stepper({ label, value, min, max, onChange, className, ...props }: StepperProps) {
  if (!Number.isInteger(value) || !Number.isInteger(min) || !Number.isInteger(max) || min > max || value < min || value > max) {
    throw new Error(`Stepper "${label}" requires an integer value between its integer bounds`)
  }
  return (
    <div className={cn('inline-flex h-9 items-center rounded-lg border bg-background', className)} role="group" aria-label={label} {...props}>
      <Button type="button" variant="ghost" size="icon" className="size-8 rounded-r-none" disabled={value === min} aria-label={`Decrease ${label}`} onClick={() => onChange(value - 1)}>
        <Minus aria-hidden="true" />
      </Button>
      <output className="min-w-8 text-center text-sm font-semibold tabular-nums" aria-live="polite">{value}</output>
      <Button type="button" variant="ghost" size="icon" className="size-8 rounded-l-none" disabled={value === max} aria-label={`Increase ${label}`} onClick={() => onChange(value + 1)}>
        <Plus aria-hidden="true" />
      </Button>
    </div>
  )
}
